
import palette from './palette';

const DEFAULT_FONT = ['Poppins', 'sans-serif'].join(',');

const tag = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 'normal',
  color: palette.common.white,
  padding: '3px 10px',
  borderRadius: '2px',
  display: 'inline-block',
};

const typography = {
  fontFamily: DEFAULT_FONT,
  menuCaption: {
    fontSize: '14px',
    fontWeight: 700,
    color: '#121926',
    padding: '6px',
    textTransform: 'capitalize',
    marginTop: '10px',
  },
  subMenuCaption: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#697586',
    textTransform: 'capitalize',
  },
  h6: {
    fontWeight: 600,
    color: palette.common.black,
    fontSize: '12px',
  },
  h5: {
    fontSize: '14px',
    color: palette.common.black,
    fontWeight: 600,
  },
  h4: {
    fontSize: '16px',
    color: '#697586',
    fontWeight: 600,
  },
  h3: {
    fontSize: '20px',
    fontWeight: 600,
  },
  h2: {
    fontSize: '24px',
    color: '#697586',
    fontWeight: 500,
  },
  h1: {
    fontSize: '28',
    color: '#697586',
    fontWeight: 700,
  },
  body: {
    fontSize: '12px',
    fontWeight: 400,
  },
  body1: {
    fontSize: '14px',
    fontWeight: 400,
  },
  body2: {
    fontSize: '16px',
    fontWeight: 400,
    color: '#364152',
  },

  redTag: { ...tag, background: palette.red[200] },
  orangeTag: { ...tag, background: palette.orange[100] },
};
export default typography;
